import React, { Component } from 'react'
import Modal from './Modal'
import styled from 'styled-components'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject, observer } from 'mobx-react';
import Parse from 'parse'
import { Form, Input } from 'formsy-react-components';
import { Row, Col } from 'react-bootstrap';

class EditContractFeeModal extends Component {

  constructor(props) {
		super(props)
		this.state = {
			contract: this.props.contract,
			loading: false,
			success: false,
      fee: this.props.contract.fee
		}
  }

  open = () => {
    this.child.open()
  }

	componentDidUpdate(prevProps) {
  	if (prevProps.contract !== this.props.contract)
  		this.setState({ contract: this.props.contract, success: false, loading: false, fee: this.props.contract.fee })
	}

  edit = () => {
    this.setState({ loading: true })

    console.log("DALKSDKASKD");

    Parse.Cloud.run("generateNewContract", { contractId: this.state.contract.objectId, fee: this.state.fee }).then(() => {
      // this.props.editFee(this.state.fee)
      this.setState({ success: true, loading: false })
    }).catch(error => {
      this.setState({ success: false, loading: false })
      console.error("error editFeeError", error)
    })
  }

  render() {
    if(!this.state.success)
      return (
        <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
          <Heading>Betrag anpassen</Heading>

          <Text style={{marginTop: 20}}>
            Durch das Ändern wird der Vertrag erneut ausgesendet.
          </Text>

          <Row className="accept-contract">
          <Form
            style={{marginTop: 20, textAlign: "center"}}
            className={'dashboard-form'}
            layout={'vertical'}>

            <Col md={12} style={{margin: 0}}>
              <Input
                name="fee"
                label="Jahres Betrag"
                value={ this.state.fee }
                type="number"
                required
                onChange={(name, value) => this.setState({ fee: Number(value) })}
                addonAfter={"€"}
                // style={{textAlign: "left"}}
              />
            </Col>
            <Col md={12}>
            <LogeButtonSlim
              hoverFontColor={"white"}
              style={{margin: "20px 0"}}
              disabled={this.state.loading}
              onClick={ this.edit }>
                { this.state.loading ? "Loading ..." : "Betrag ändern"}
            </LogeButtonSlim>
          </Col>
          </Form>
          </Row>
          <a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>abbrechen</a>
        </Modal>
      )
    else
      return(
        <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
          <Heading>Betrag geändert!</Heading>

          <Text style={{marginTop: 20}}>
              Der Jahres Betrag wurde erfolgreich geändert, und der dazugehörige Vertrag erneut ausgesendet.
          </Text>

          <LogeButtonSlim
            hoverFontColor={"white"}
            style={{marginTop: 20}}
            onClick={() => { this.child.closeModal() }}>
              schließen
          </LogeButtonSlim><br />
        </Modal>
      )
  }
}

export default EditContractFeeModal;

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Modals/EditContractFeeModal.js